export function string2PositiveInt(value) {
    try {
        // 处理 undefined、null、空字符串
        if (value == null || value === '' || value === undefined)
            return undefined;
        const num = Number(value);
        // 处理 NaN 和小于1的情况
        if (isNaN(num) || num < 1)
            return undefined;
        return Math.floor(num);
    }
    catch (error) {
        return undefined;
    }
}
export function stringToFloat(value) {
    try {
        const num = Number(value);
        return !isNaN(num) && num !== 0 ? num : undefined;
    }
    catch (error) {
        return undefined;
    }
}
